// Vue
import { mountApp, setupSentry } from "@/main.js";
import Contact from '@/pages/contact/Contact.vue';
import store from '@/pages/contact/store.js';
import router from '@/pages/contact/router.js';
import 'vite/modulepreload-polyfill';

const contact = mountApp(Contact, {store: store, router: router});
const sentry = setupSentry(contact, router);
contact.config.globalProperties.$sentry = sentry;
contact.mount('#contact');
